import { render, staticRenderFns } from "./CienIdeas.vue?vue&type=template&id=29793ca4&scoped=true"
import script from "./CienIdeas.vue?vue&type=script&lang=js"
export * from "./CienIdeas.vue?vue&type=script&lang=js"
import style0 from "./CienIdeas.vue?vue&type=style&index=0&id=29793ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29793ca4",
  null
  
)

export default component.exports